require('./angular');
module.exports = angular;



/*****************
 ** WEBPACK FOOTER
 ** ./~/angular/index.js
 ** module id = 9
 ** module chunks = 1
 **/